export const THREESHAPE_OAUTH_STATE_KEY = "3shape_state";
export const THREESHAPE_OAUTH_CODE_VERIFIER_KEY = "3shape_code_verifier";
